/*
GPS DataViz

Copyright © 2021 GPSDataViz

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/
import React, { useContext, useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { Table, Select, Space, Popconfirm, Button, notification } from "antd";
import { TrainingAPI } from "../../api/TrainingAPI";
import "../../Styles/styles-EditableTable.css";

// const EditableContext = React.createContext(null);

const { Option, OptGroup } = Select;

export class DrillCompareTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [
        {
          key: 1,
          selected_drill: undefined,
          selected_date: undefined,
          date: [],
        },
      ],
      count: 1,
    };

    this.render = this.render.bind(this);
  }

  trainingAPI = new TrainingAPI();

  onDrillChange = (val, keys) => {
    let split_val = keys["value"].split("_");
    let key = parseInt(split_val[0]);
    split_val.shift();
    val = split_val.join("");

    this.trainingAPI.getDrillDates(val).then((dates_in) => {
      let temp = this.state.data;
      let new_temp = temp.map((row, i) => {
        if (row["key"] === key) {
          return {
            key: row.key,
            date: dates_in,
            selected_drill: val,
            selected_date: undefined,
          };
        } else {
          return {
            key: row.key,
            date: row.date,
            selected_drill: row.selected_drill,
            selected_date: row.selected_date,
          };
        }
      });
      this.setState({ data: new_temp });
    });
  };

  onDateChange = (val, keys) => {
    let split_val = keys["value"].split("_");
    let key = parseInt(split_val[0]);
    split_val.shift();
    val = split_val.join("");
    let temp = this.state.data;
    let new_temp = temp.map((row, i) => {
      if (row["key"] === key) {
        return {
          key: row.key,
          date: row.date,
          selected_drill: row.selected_drill,
          selected_date: val,
        };
      } else {
        return {
          key: row.key,
          date: row.date,
          selected_drill: row.selected_drill,
          selected_date: row.selected_date,
        };
      }
    });
    this.setState({ data: new_temp });
  };

  handleAdd = () => {
    let temp_count = this.state.count;
    temp_count += 1;
    let temp = this.state.data;
    let new_data = {
      key: temp_count,
      date: [],
      selected_drill: undefined,
      selected_date: undefined,
    };

    this.setState({ count: temp_count, data: [...temp, new_data] });
  };

  handleDelete = (key) => {
    let temp = this.state.data;

    var filtered = temp.filter(function (value, index, arr) {
      return value["key"] !== key;
    });

    this.setState({ data: filtered });
  };

  get = () => {
    const incompleteData = this.state.data.some(d => !d.selected_date || !d.selected_drill );

    if (incompleteData) {
       notification.error({
        key: 'invalid-data-notification',
        message: `Please select valid drill/date for comparison`,
        description: '',
        placement: 'top',
        style: {
          width: '30rem'
        },
        duration: 10
      })
      return;
    }
   
    this.trainingAPI
      .getDrillBreakdownTeam(this.state.data)
      .then((data) => this.props.set_data(data));
  };

  render() {
    let columns = [
      {
        title: "Drill",
        dataIndex: "drills",
        key: "drills",
        width: "45%",
        render: (drills, key) => (
          <Select
            showSearch
            style={{ width: 200 }}
            placeholder="Choose Drill"
            onChange={this.onDrillChange}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {this.props.drills.length !== 0 ? (
              this.props.drills.map((drill, i) => {
                return (
                  <Option key={i} value={key["key"] + "_" + drill}>
                    {drill}
                  </Option>
                );
              })
            ) : (
              <></>
            )}
          </Select>
        ),
      },
      {
        title: "Date",
        dataIndex: "date",
        key: "date",
        width: "45%",
        render: (date, key) =>
          date.length !== 0 ? (
            <Select
              showSearch
              style={{ width: 200 }}
              placeholder="Choose Date"
              onChange={this.onDateChange}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {date.length !== 0 ? (
                date.map((date_in, i) => {
                  return (
                    <Option key={i} value={key["key"] + "_" + date_in["date"]}>
                      {date_in["date"]}
                    </Option>
                  );
                })
              ) : (
                <></>
              )}
            </Select>
          ) : (
            <p className="temp-text-drill-table" style={{ color: "#B0B0B0" }}>
              Select Drill First
            </p>
          ),
      },
      {
        title: "",
        dataIndex: "operation",
        width: "10%",
        render: (_, key) => (
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => this.handleDelete(key["key"])}
          >
            <a style={{ color: "#1890ff" }}>Delete</a>
          </Popconfirm>
        ),
      },
    ];

    return (
      <>
        <Button
          className="add-drill-button"
          onClick={this.handleAdd}
          style={{ marginBottom: 16 }}
        >
          Add a Drill
        </Button>
        <Table columns={columns} dataSource={this.state.data} />
        <Button
          className="drill-table-submit"
          type="primary"
          onClick={this.get}
        >
          Submit
        </Button>
      </>
    );
  }
}
